import { brandColors } from "../theme";

// Estilos compartidos por los formularios de publicar/editar (propiedades,
// autos, ofertas, eventos): el botón de subir imagen/video, la miniatura de
// previsualización y su botón de eliminar. Antes cada pantalla tenía su
// propia copia (o, en el caso de editar propiedades, una copia rota que
// referenciaba claves que no existían) y terminaban todas ligeramente
// distintas — de acá en más, cualquier cambio de estilo se hace en un solo
// lugar.
export const uploadButtonSx = (hasError) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "50px",
  backgroundColor: brandColors.action,
  border: `2px solid ${hasError ? "#d32f2f" : brandColors.accent}`,
  mt: 2,
  borderRadius: "8px",
  color: brandColors.onAction,
});

export const uploadProgressSx = {
  position: "absolute",
  color: brandColors.onAction,
};

export const mediaPreviewStyle = {
  width: "100px",
  height: "100px",
  objectFit: "cover",
  margin: "5px",
  border: `1px solid ${brandColors.divider}`,
  borderRadius: "5px",
};

export const mediaPreviewBoxSx = (hasError) => ({
  position: "relative",
  width: "100%",
  height: "100%",
  border: hasError ? "1.5px solid #d32f2f" : "1.5px solid black",
  borderRadius: "10px",
});

// Botón circular chico tipo "glass" (fondo oscuro semitransparente + blur)
// con un ícono CloseIcon adentro — se usa junto con removeMediaButtonSx en
// vez del viejo círculo rojo con una "X" de texto.
export const removeMediaButtonSx = {
  minWidth: 0,
  width: "28px",
  height: "28px",
  padding: 0,
  position: "absolute",
  top: "6px",
  right: "6px",
  borderRadius: "50%",
  backgroundColor: "rgba(20,20,20,0.55)",
  backdropFilter: "blur(4px)",
  color: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
  transition: "background-color 0.15s ease, transform 0.15s ease",
  "&:hover": {
    backgroundColor: "rgba(20,20,20,0.8)",
    transform: "scale(1.08)",
  },
};

export const removeMediaIconSx = { fontSize: 16 };
